// package: activity.cardgame
// file: activity/cardgame/model.proto


export const WithDrawGift = {
    encode(object) {
        const message = {};
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            index: 0,
        };

        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const FreeBuy = {
    encode(object) {
        const message = {};
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            index: 0,
        };

        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const VideoGift = {
    encode(object) {
        const message = {};
        if (object.low != null) {
            if (object.low !== 0) {
                message.low = object.low | 0;
            }
        }
        if (object.high != null) {
            if (object.high !== 0) {
                message.high = object.high | 0;
            }
        }
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = object.count | 0;
            }
        }
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            low: 0,
            high: 0,
            count: 0,
            index: 0,
        };

        if (message.low != null) {
            object.low = message.low;
        }
        if (message.high != null) {
            object.high = message.high;
        }
        if (message.count != null) {
            object.count = message.count;
        }
        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const GeneralRedPacketGift = {
    encode(object) {
        const message = {};
        if (object.low != null) {
            if (object.low !== 0) {
                message.low = object.low | 0;
            }
        }
        if (object.high != null) {
            if (object.high !== 0) {
                message.high = object.high | 0;
            }
        }
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = object.count | 0;
            }
        }
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            low: 0,
            high: 0,
            count: 0,
            index: 0,
        };

        if (message.low != null) {
            object.low = message.low;
        }
        if (message.high != null) {
            object.high = message.high;
        }
        if (message.count != null) {
            object.count = message.count;
        }
        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const CashRedPacketGift = {
    encode(object) {
        const message = {};
        if (object.low != null) {
            if (object.low !== 0) {
                message.low = Number(object.low);
            }
        }
        if (object.high != null) {
            if (object.high !== 0) {
                message.high = Number(object.high);
            }
        }
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = Number(object.count);
            }
        }
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            low: 0,
            high: 0,
            count: 0,
            index: 0,
        };

        if (message.low != null) {
            object.low = message.low;
        }
        if (message.high != null) {
            object.high = message.high;
        }
        if (message.count != null) {
            object.count = message.count;
        }
        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const MiaoCoinGift = {
    encode(object) {
        const message = {};
        if (object.low != null) {
            if (object.low !== 0) {
                message.low = object.low | 0;
            }
        }
        if (object.high != null) {
            if (object.high !== 0) {
                message.high = object.high | 0;
            }
        }
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = object.count | 0;
            }
        }
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = object.index | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            low: 0,
            high: 0,
            count: 0,
            index: 0,
        };

        if (message.low != null) {
            object.low = message.low;
        }
        if (message.high != null) {
            object.high = message.high;
        }
        if (message.count != null) {
            object.count = message.count;
        }
        if (message.index != null) {
            object.index = message.index;
        }
        return object;
    },
};

export const OneYuanBuyFund = {
    encode(object) {
        const message = {};
        if (object.low != null) {
            if (object.low !== 0) {
                message.low = String(object.low);
            }
        }
        if (object.high != null) {
            if (object.high !== 0) {
                message.high = String(object.high);
            }
        }
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = String(object.count);
            }
        }
        if (object.index != null) {
            if (object.index !== 0) {
                message.index = String(object.index);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            low: 0,
            high: 0,
            count: 0,
            index: 0,
        };

        if (message.low != null) {
            object.low = parseInt(message.low, 10);
        }
        if (message.high != null) {
            object.high = parseInt(message.high, 10);
        }
        if (message.count != null) {
            object.count = parseInt(message.count, 10);
        }
        if (message.index != null) {
            object.index = parseInt(message.index, 10);
        }
        return object;
    },
};

export const Gift = {
    encode(object) {
        const message = {};
        if (object.withDrawGift != null) {
            message.withDrawGift = WithDrawGift.encode(object.withDrawGift);
        }
        if (object.videoGift != null) {
            message.videoGift = VideoGift.encode(object.videoGift);
        }
        if (object.generalRedPacketGift != null) {
            message.generalRedPacketGift = GeneralRedPacketGift.encode(object.generalRedPacketGift);
        }
        if (object.cashRedPacketGift != null) {
            message.cashRedPacketGift = CashRedPacketGift.encode(object.cashRedPacketGift);
        }
        if (object.miaoCoinGift != null) {
            message.miaoCoinGift = MiaoCoinGift.encode(object.miaoCoinGift);
        }
        if (object.freeBuy != null) {
            message.freeBuy = FreeBuy.encode(object.freeBuy);
        }
        if (object.oneYuanBuyFund != null) {
            message.oneYuanBuyFund = OneYuanBuyFund.encode(object.oneYuanBuyFund);
        }
        return message;
    },

    decode(message) {
        const object = {
            withDrawGift: null,
            videoGift: null,
            generalRedPacketGift: null,
            cashRedPacketGift: null,
            miaoCoinGift: null,
            freeBuy: null,
            oneYuanBuyFund: null,
        };

        if (message.withDrawGift != null) {
            object.withDrawGift = WithDrawGift.decode(message.withDrawGift);
        }
        if (message.videoGift != null) {
            object.videoGift = VideoGift.decode(message.videoGift);
        }
        if (message.generalRedPacketGift != null) {
            object.generalRedPacketGift = GeneralRedPacketGift.decode(message.generalRedPacketGift);
        }
        if (message.cashRedPacketGift != null) {
            object.cashRedPacketGift = CashRedPacketGift.decode(message.cashRedPacketGift);
        }
        if (message.miaoCoinGift != null) {
            object.miaoCoinGift = MiaoCoinGift.decode(message.miaoCoinGift);
        }
        if (message.freeBuy != null) {
            object.freeBuy = FreeBuy.decode(message.freeBuy);
        }
        if (message.oneYuanBuyFund != null) {
            object.oneYuanBuyFund = OneYuanBuyFund.decode(message.oneYuanBuyFund);
        }
        return object;
    },
};

export const VideoReportParam = {
    encode(object) {
        const message = {};
        if (object.transactionID != null) {
            if (object.transactionID !== "") {
                message.transactionID = String(object.transactionID);
            }
        }
        if (object.position != null) {
            if (object.position !== "") {
                message.position = String(object.position);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            transactionID: "",
            position: "",
        };

        if (message.transactionID != null) {
            object.transactionID = message.transactionID;
        }
        if (message.position != null) {
            object.position = message.position;
        }
        return object;
    },
};


